import React, { useState, useEffect } from "react";
import {

  Grid, Typography, Button, Box, Avatar
} from "@mui/material"; 

import moment from "moment";
import EditEvent from "../my_care_journey/edit_event";

import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import { buttonviewmore, darkcolor, pcolor, pointer, scroll } from "../../style2";
const date = {
  fontWeight: "normal",
  fontSize: 12
};
const description = {
  fontWeight: "normal",
  fontSize: 14,
};
const title = {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 14,
    color: "#001244",
  };

// const useStyles = makeStyles((theme) => ({
//   title: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "bold",
//     fontSize: 14,
//     color: "#001244",
//   },
//   description: {
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "rgba(0, 18, 68, 0.6)",
//   },
//   date: {
//     fontWeight: "normal",
//     fontSize: 12,
//     color: "rgba(0, 18, 68, 0.3)",
//   },
//   button: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#FF767E",
//     textTransform: "unset",
//     "&:hover": {
//       background: "#FFFFFF",
//     },
//   },
//   avatar: {
//     background: "#4bc0a9",
//   },
//   scroll: {
//     overflow: "auto",
//     maxHeight: 197,
//     [theme.breakpoints.down("sm")]: {
//       maxHeight: 180,
//     },
//   },
// }));

function Allergies({ searchValue, type }) {

  const [rowsPerPage, setRowsPerPage] = useState(3);

  const [allergies, setAllergies] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const rowsPerPageValue = 4;
  const ls = new AccessLocalStorage();
  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const [openEditAllergy, setOpenEditAllergy] = useState(false);
  const [openViewAllergy, setOpenViewAllergy] = useState(false);
  const [openAddAllergy, setOpenAddAllergy] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const [selectedAllergy, setSelectedAllergy] = useState([]);

  const handleClickOpenViewAllergy = (selectedAllergy) => {
    setSelectedAllergy(selectedAllergy);
    setOpenViewAllergy(true);
    //console.log("event view id:", selectedAllergy.id);
  };
  const handleClickCloseAllergy = () => {
    setOpenEditAllergy(false);
    setOpenViewAllergy(false);
    setOpenAddAllergy(false);
    setSelectedAllergy(""); // reset the selected event so the edit dialog will contain new data
  };


  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(`${getApiUrl()}${process.env.REACT_APP_GET_ALLERGIES}/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        try {
          setAllergies(data.filter(t => t.allergyType === type));
        } catch (err) {
          setAllergies([]);
        }
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const emptyRows =
    allergies.filter((val) => {
      if (searchValue === "") {
        return val;
      } else if (
        Object.values(val)
          .join(" ")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      ) {
        return Object.values(val);
      }
    }).length === 0
      ? rowsPerPage
      : rowsPerPage -
      allergies.filter((val) => {
        if ((searchValue = "")) {
          return val;
        } else if (
          Object.values(val)
            .join(" ")
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        ) {
          return Object.values(val);
        }
      }).length;
  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore ? setRowsPerPage(rowsPerPageValue) : setRowsPerPage(allergies.length);
  };

  return (
    <div>
      <Box paddingTop={2} />
      <Box component="div" sx={{ ...scroll, height: 300, maxHeight: 300 }}>
        {allergies != null && allergies.length > 0 ? allergies
          .filter((val) => {
            if (searchValue === "") {
              return val;
            } else if (
              Object.values(val)
                .join(" ")
                .toLowerCase()
                .includes(searchValue.toLowerCase())
            ) {
              return Object.values(val);
            }
          })
          .slice(0, rowsPerPage)
          .map((allergie) => (
            <Box component="div" key={allergie.id}>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                spacing={2} sx={{ marginBottom: "15px" }}
              >
                <Grid item sx={{ fontWeight: "normal" }}>
                  <Avatar sx={{ cursor: "pointer", width: "50px", height: "50px", backgroundColor: pcolor }}>
                    {allergie.allergyName.charAt(0)}
                  </Avatar>
                </Grid>
                <Grid item xs direction="column" spacing={2}>
                  <Box component="div" sx={pointer} >
                    <Typography sx={{ ...title, color: pcolor }}>
                      {allergie.allergyName}
                    </Typography>
                    <Typography sx={description}>
                      {allergie.description}
                    </Typography>
                    <Typography sx={date} style={{ color: darkcolor }}>
                      {moment(allergie.createdOn).format("DD/MM/YY")}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )) : loading ? null : <Box><Typography style={{ textAlign: "center" }}>No Allergies</Typography></Box>}
      </Box>
      {/* {emptyRows > 0 && (
        <TableRow style={{ height: 67 * emptyRows }}></TableRow>
      )}
      <Grid container justifyContent="center" style={{ maxHeight: 3 }}>
        {emptyRows > 0 || allergies.length === 3 ? (
          <TableRow style={{ height: 36 }}></TableRow>
        ) : (
          // <Viewmore handleViewMore={handleViewMore}></Viewmore>
          true
        )}
      </Grid> */}
      <Grid Container style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Grid item>
          {!viewMore && allergies.length > rowsPerPageValue ? (
            <Button sx={buttonviewmore} onClick={handleViewMore}>
              Show More
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <EditEvent
        open={openViewAllergy}
        handleClose={handleClickCloseAllergy}
        eventType={"Allergy"}
        eventData={selectedAllergy}
        disabled={true}
      />
    </div>

  );
}

export default Allergies;
